module.exports = __webpack_public_path__ + "static/img/ZZtu7@2x.54e9cb17.png";